export const ERRORS: any = {
	APPLICATIONS_ALREADY_SUBMITTED: 'Application already submitted by this user',
	USER_IS_MEMBER_IN_TEAM: 'You are already a member of another team group',
	MEMBER_ALREADY_IN_TEAM: 'One of your team members is already in another team',
};
